// Global
import React from 'react';

// Local
import { HeroProps } from '../Hero';
import styles from './HeroSimple.module.scss';
import { HeroDetailCard } from '../HeroDetailCard/HeroDetailCard';
import { HeroDecor } from '../HeroDecor/HeroDecor';
import useIsEditing from 'lib/hooks/sitecore/useIsEditing';
import clsx from 'clsx';
import { ActionToolbar } from 'components/helpers/ActionToolbar';

export const HeroSimple = (props: HeroProps) => {
  /*
   * Rendering
   */
  const isEditing = useIsEditing();
  return (
    <div className={clsx(styles.heroSimple, props?.isImagePresent && styles.heroSimple_withImage)}>
      {(props?.isImagePresent || isEditing) && (
        <div className={styles.imageContainer}>
          {props?.contentPageImage}
          {props?.contentPageImage && <HeroDecor />}
        </div>
      )}
      <div className={styles.heroSimpleContentBackground}>
        <div className={styles.heroSimpleContentWrapper}>
          <div className={styles.sectionHeading}>
            <HeroDetailCard {...props} contentAlignment="center" />
            {!props.disableHeroActionToolbar && (
              <div
                className={clsx(
                  styles.actionToolBarContainer,
                  props.isArticlePage && styles.articlePageAlignment
                )}
              >
                <ActionToolbar
                  actions={props.heroActionToolbarButtons}
                  toolbarIdentifier={props.heroActionToolbarIdentifier}
                  variant="horizontal"
                  className={!props.isArticlePage ? styles.centerAlignActionToolbar : undefined}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {props?.externalPageImage && (
        <div>
          {props?.editingHelpText}
          {props?.externalPageImage}
        </div>
      )}
    </div>
  );
};
